import { Component, OnInit, Input } from '@angular/core';
import { TabService } from '../../../../../../services';

@Component({
  standalone: false,
  selector: 'spk-tab',
  templateUrl: './spk-tab.component.html',
  styleUrls: ['./spk-tab.component.scss']
})
export class SpkTabComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;
  @Input() class: string;
  @Input() active: boolean;

  constructor(private tabService: TabService) { }

  ngOnInit() {
  }

  updateTab(tab: string) {
    this.tabService.updateTab(tab);
  }
}
